// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__rJ881","videos__content":"Videos_videos__content__FSI2w"};